import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: string[] = []

const claimSlice = createSlice({
  name: 'claim',
  initialState: initialState,
  reducers: {
    claimsSet: (state, action: PayloadAction<string[]>) => {
      return action.payload // Replace the state with the new array
    },
    claimsRemoved: () => {
      return [] // Replace the state with an empty array
    },
  },
})

export const { claimsSet, claimsRemoved } = claimSlice.actions
export default claimSlice.reducer